/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AddWishlistItem$Params {
  productId: number;
}

export function addWishlistItem(http: HttpClient, rootUrl: string, params: AddWishlistItem$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'data'?: boolean;
}>> {
  const rb = new RequestBuilder(rootUrl, addWishlistItem.PATH, 'put');
  if (params) {
    rb.path('productId', params.productId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'data'?: boolean;
      }>;
    })
  );
}

addWishlistItem.PATH = '/api/v1/wishlist/{productId}';
